import {Component} from 'react'
import Loader from 'react-loader-spinner'
import {BsSearch} from 'react-icons/bs'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import Navbar from '../Navbar'
import EmploymentTypeItem from '../EmploymentTypeItem'
import SalaryRangeItem from '../SalaryrangeItem'
import DisplayJobs from '../DisplayJobs'
import './index.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

class Jobs extends Component {
  state = {
    profile: {},
    isLoading: true,
    employmentType: [],
    minimumPackage: '',
    searchInput: '',
    jobs: [],
    isJobsLoading: true,
    isJobsReqSuccess: true,
    isProfileReqSuccess: true,
  }

  componentDidMount() {
    this.getProfileDetails()
    this.getJobsDetails()
  }

  getJobsDetails = async () => {
    const {employmentType, minimumPackage, searchInput} = this.state
    const employmentTypeString = employmentType.join(',')
    const getJobsUrl = `https://apis.ccbp.in/jobs?employment_type=${employmentTypeString}&minimum_package=${minimumPackage}&search=${searchInput}`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(getJobsUrl, options)
    if (response.ok) {
      const jobsData = await response.json()
      const {jobs} = jobsData
      const convertedJobsData = jobs.map(each => ({
        companyLogoUrl: each.company_logo_url,
        employmentType: each.employment_type,
        id: each.id,
        jobDescription: each.job_description,
        title: each.title,
        location: each.location,
        packagePerAnnum: each.package_per_annum,
        rating: each.rating,
      }))
      this.setState({
        jobs: convertedJobsData,
        isJobsLoading: false,
        isJobsReqSuccess: true,
      })
    } else {
      this.setState({isJobsReqSuccess: false})
    }
  }

  getProfileDetails = async () => {
    const url = 'https://apis.ccbp.in/profile'
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(url, options)
    if (response.ok) {
      const data = await response.json()
      this.setState({
        profile: data.profile_details,
        isLoading: false,
        isProfileReqSuccess: true,
      })
    } else {
      this.setState({isProfileReqSuccess: false})
    }
  }

  renderLoading = () => (
    <div data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height={40} width={100} />
    </div>
  )

  renderProfile = () => {
    const {profile} = this.state
    return (
      <div className="profile">
        <img
          className="profile-image"
          src={profile.profile_image_url}
          alt="profile"
        />
        <h1 className="profile-name">{profile.name}</h1>
        <p className="profile-bio">{profile.short_bio}</p>
      </div>
    )
  }

  renderDisplayJobs = () => {
    const {jobs} = this.state
    if (jobs.length === 0) {
      return (
        <div className="empty-jobs-container">
          <img
            className="no-jobs"
            src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
            alt="no jobs"
          />
          <h1 className="no-jobs-heading">No jobs Found</h1>
          <p className="no-jobs-para">
            We could not find any jobs. Try other filters
          </p>
        </div>
      )
    }
    return (
      <ul className="jobs-list">
        {jobs.map(each => (
          <DisplayJobs key={each.id} jobDetails={each} />
        ))}
      </ul>
    )
  }

  renderProfileFailure = () => (
    <div>
      <button
        onClick={this.onClickProfileRetry}
        className="retry"
        type="button"
      >
        Retry
      </button>
    </div>
  )

  renderJobsFailure = () => (
    <div>
      <button onClick={this.onClickJobsRetry} className="retry" type="button">
        Retry
      </button>
    </div>
  )

  updateEmploymentType = (prevState, id) => {
    const {employmentType} = prevState
    if (employmentType.includes(id)) {
      const newEmploymentType = employmentType.filter(each => each !== id)
      return newEmploymentType
    }
    const newEmploymentType = [...employmentType, id]
    return newEmploymentType
  }

  onSelectTypeOfEmployment = id => {
    this.setState(
      prevState => ({
        employmentType: this.updateEmploymentType(prevState, id),
      }),
      this.getJobsDetails,
    )
  }

  onChangePackage = id => {
    this.setState({minimumPackage: id}, this.getJobsDetails)
  }

  onSearchJob = event => {
    this.setState({searchInput: event.target.value}, this.getJobsDetails)
  }

  onClickProfileRetry = () => {
    this.setState({isProfileReqSuccess: true}, this.getProfileDetails)
  }

  onClickJobsRetry = () => {
    this.setState({isJobsReqSuccess: true}, this.getJobsDetails)
  }

  render() {
    const {
      isLoading,
      isJobsLoading,
      searchInput,
      isJobsReqSuccess,
      isProfileReqSuccess,
    } = this.state
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken === undefined) {
      return <Redirect to="/login" />
    }
    return (
      <>
        <Navbar />
        <div className="jobs-bg-container">
          <div className="profile-filter-container">
            {isLoading && this.renderLoading()}
            {isProfileReqSuccess && this.renderProfile()}
            {isProfileReqSuccess === false && this.renderProfileFailure()}
            <hr className="horizontal-line" />
            <h1 className="employment-heading">Type of employment</h1>
            <ul>
              {employmentTypesList.map(each => (
                <EmploymentTypeItem
                  key={each.employmentTypeId}
                  employmentTypeDetails={each}
                  onSelectTypeOfEmployment={this.onSelectTypeOfEmployment}
                />
              ))}
            </ul>
            <hr className="horizontal-line" />
            <h1 className="employment-heading">Salary Range</h1>
            <ul>
              {salaryRangesList.map(each => (
                <SalaryRangeItem
                  key={each.salaryRangeId}
                  salaryRangeDetails={each}
                  onChangePackage={this.onChangePackage}
                />
              ))}
            </ul>
          </div>
          <div className="jobs-container">
            <div className="search-container">
              <input
                onChange={this.onSearchJob}
                value={searchInput}
                className="search"
                type="search"
                placeholder="search"
              />
              <button
                className="search-btn"
                type="button"
                data-testid="searchButton"
              >
                <BsSearch className="search-icon" />
              </button>
            </div>
            {isJobsLoading && this.renderLoading()}
            {isJobsReqSuccess && this.renderDisplayJobs()}
            {isJobsReqSuccess === false && this.renderJobsFailure()}
          </div>
        </div>
      </>
    )
  }
}
export default Jobs
